import { extendTheme } from '@mui/material/styles'
import { ruRU } from '@mui/material/locale'
import { createReldoComponents } from './components'
import { muiShadows, reldoColorSchemes, reldoTokens, reldoTypography } from './tokens'

export const TOOLPAD_COLOR_SCHEME_SELECTOR = 'data-toolpad-color-scheme'
export const TOOLPAD_MODE_STORAGE_KEY = 'toolpad-mode'
export const TOOLPAD_COLOR_SCHEME_STORAGE_KEY = 'toolpad-color-scheme'

const reldoTheme = extendTheme({
	cssVarPrefix: 'reldo',
	colorSchemeSelector: TOOLPAD_COLOR_SCHEME_SELECTOR,
	defaultColorScheme: 'light',
	colorSchemes: reldoColorSchemes,
	typography: reldoTypography,
	shape: { borderRadius: reldoTokens.radius.md },
	shadows: muiShadows,
	components: createReldoComponents(reldoTokens),
}, ruRU)

export default reldoTheme
